// John Eldhose 20180613
import React, { Component } from 'react';
import { Button, Grid, IconButton, InputAdornment, Snackbar, TextField, Typography } from '@material-ui/core';
import { Cloud, Contacts, Create, Email, Person, Phone, VpnKey, Visibility, VisibilityOff, Work } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import { getProfile } from '../../Api/getProfile';
import { updateProfile } from '../../Api/updateProfile';

class Profile extends Component {

  state = {
    FirstName: '',
    LastName: '',
    username: '',
    email: '',
    CompanyDescription: '',
    password: '',
    phone: '',
    CompanyName: '',
    showPassword: false,
    Message: '',
    errorMessage: '',
    disableSave: false
  }
  componentWillMount() {
    getProfile()
      .then((prof) => {
        if(prof['status'] === 'true')
          ['FirstName', 'LastName', 'username', 'email', 'CompanyDescription', 'phone', 'CompanyName'].map((key) => {
            this.setState({ [key]: prof['data'][key] });
            return true;
          });
      })
      .catch((error) => {
        console.log(error);
      })
  }
  handleUserInput(event, lower = false) {
    this.setState({ [event.target.name]: (
      lower ? event.target.value.toLowerCase() : event.target.value
    ) });
  }
  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  }
  handleMouseDownPassword = event => {
    event.preventDefault();
  }
  handleSave = () => {
    this.setState({ disableSave: true });
    var data = {
      FirstName: this.state.FirstName,
      LastName: this.state.LastName,
      username: this.state.username,
      email: this.state.email,
      CompanyDescription: this.state.CompanyDescription,
      password: this.state.password,
      phone: this.state.phone,
      CompanyName: this.state.CompanyName,
      disableSave: false
    };
    updateProfile(data)
      .then((prof) => {
        if(prof['status'] === 'true')
          this.setState({ Message: 'Changes saved', errorMessage: '' });
        else {
          if(prof['status'] !== '')
            this.setState({ Message: '', errorMessage: prof['status'] });
          else
            this.setState({ Message: '', errorMessage: 'Failed to save' });
          this.setState({ disableSave: false });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ Message: '', errorMessage: 'Failed to save', disableSave: false });
      })
  }

  render() {
    return (
      <div>
        <Typography variant='display1'>
          <font color='#385687'>Update your profile</font>
        </Typography>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Contacts className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='First Name'
                defaultMessage='First Name'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='FirstName'
                    value={this.state.FirstName}
                    onChange={(event) => this.handleUserInput(event)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Contacts className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Last Name'
                defaultMessage='Last Name'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='LastName'
                    value={this.state.LastName}
                    onChange={(event) => this.handleUserInput(event)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Email className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Email Address'
                defaultMessage='Email Address'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='email'
                    value={this.state.email}
                    onChange={(event) => this.handleUserInput(event, true)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Work className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Company Name'
                defaultMessage='Company Name'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='CompanyDescription'
                    value={this.state.CompanyDescription}
                    onChange={(event) => this.handleUserInput(event)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Person className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Username'
                defaultMessage='Username'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='username'
                    value={this.state.username}
                    onChange={(event) => this.handleUserInput(event, true)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <VpnKey className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Password (blank to keep same password)'
                defaultMessage='Password (blank to keep same password)'
              >
                {(msg) => (
                  <TextField
                    fullWidth
                    label={msg}
                    name='password'
                    type={this.state.showPassword ? 'text' : 'password'}
                    value={this.state.password}
                    onChange={(event) => this.handleUserInput(event)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="Toggle password visibility"
                            onClick={this.handleClickShowPassword}
                            onMouseDown={this.handleMouseDownPassword}
                          >
                            {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Phone className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Work Phone'
                defaultMessage='Work Phone'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='phone'
                    value={this.state.phone}
                    onChange={(event) => this.handleUserInput(event)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Cloud className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Company Key (For use with SurvCE|PC Cloud)'
                defaultMessage='Company Key (For use with SurvCE|PC Cloud)'
              >
                {(msg) => (
                  <TextField
                    fullWidth
                    label={msg}
                    name='CompanyName'
                    value={this.state.CompanyName}
                    onChange={(event) => this.handleUserInput(event)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <Typography variant='caption'>
          * <font color="red">Required field</font>
        </Typography>
        <Button
          variant='raised'
          color='primary'
          fullWidth
          style={{ textTransform: 'none' }}
          onClick={this.handleSave}
          disabled={this.state.disableSave}
        >
          <FormattedMessage
            id='Save Changes'
            defaultMessage='Save Changes'
          /> &nbsp;
          <Create />
        </Button>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={this.state.Message !== '' || this.state.errorMessage !== ''}
          message={
            <span>
              {this.state.Message}
              <span style={{ color: 'red' }}>
                {this.state.errorMessage}
              </span>
            </span>
          }
        />
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/components/home/Profile.js